import React from "react";

export default function OpportunityRanking({
  topOpportunities,
  onViewLead
}) {
  if (!topOpportunities || topOpportunities.length === 0) {
    return null;
  }

  return (
    <div style={{ marginBottom: 32 }}>
      <h2>🏆 Top Opportunities</h2>

      <div style={opportunityGridStyle}>
        {topOpportunities.map((lead, index) => (
          <div key={lead._id} style={opportunityCardStyle}>
            <h3 style={{ marginTop: 0 }}>
              #{index + 1} {lead.company || lead.name}
            </h3>

            <p>
              <b>Contact:</b> {lead.name}
            </p>

            <p>
              <b>Opportunity Score:</b> {lead.opportunityScore}
            </p>

            <p>
              <b>Conversion Probability:</b> {lead.conversionProbability}%
            </p>

            <p>
              <b>Pipeline:</b> {lead.stage || "New"}
            </p>

            <button
              onClick={() => onViewLead(lead)}
              style={smallActionBtn}
            >
              View Lead
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

const opportunityGridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
  gap: 16
};

const opportunityCardStyle = {
  padding: "18px",
  borderRadius: "12px",
  background: "#f8fafc",
  border: "1px solid #cbd5e1"
};

const smallActionBtn = {
  padding: "8px 12px",
  borderRadius: "8px",
  border: "none",
  background: "#0f766e",
  color: "#fff",
  fontWeight: 700,
  cursor: "pointer"
};